import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import injectSheet from 'react-jss';

import * as organizationSelectors from '../../selectors/organizationSelectors';

import routes from '../../helpers/ApplicationRoutes';

import Tabs from '../../components/Tabs';
import AddOrganizationBucket from '../organizationBuckets/AddOrganizationBucket';
import OrganizationInfo from '../organizationInfo/OrganizationInfo';
import OrganizationSettings from '../organizationSettings/OrganizationSettings';
import Paper from '@material-ui/core/Paper';

const OrganizationCover = props => {
    const { organization, isAdmin, classes } = props;

    if (!organization) {
        return null;
    }

    const pathParams = { organizationId: organization.id };

    const links = [
        {
            name: 'Projects',
            to: routes.organizationBuckets.getPath(pathParams),
        },
        {
            name: 'Members',
            to: routes.organizationMembers.getPath(pathParams),
        },
    ];

    let settings, newBucketButton;
    if (isAdmin) {
        links.push({
            name: 'Report',
            to: routes.organizationReport.getPath(pathParams),
        });

        settings = <OrganizationSettings />;
        newBucketButton = <AddOrganizationBucket />;
    }

    return (
        <Paper elevation={1} square className={classes.wrapper}>
            <div className={classes.content}>
                <OrganizationInfo />
                {settings}
                {newBucketButton}
            </div>
            <div className={classes.tabs}>
                <Tabs links={links} />
            </div>
        </Paper>
    );
};

const mapStateToProps = state => ({
    organization: organizationSelectors.getOrganization(state),
    isAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(state),
});

OrganizationCover.propTypes = {
    organization: PropTypes.object,
    isAdmin: PropTypes.bool,
};

OrganizationCover.defaultProps = {
    organization: undefined,
    isAdmin: false,
};

const style = ({ spacing, palette }) => {
    return {
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexGrow: 1,
            padding: [spacing.unit * 3, spacing.unit * 3, 0, spacing.unit * 3],
        },
        content: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            maxWidth: spacing.maxWidth,
        },
        tabs: {
            width: '100%',
            maxWidth: spacing.maxWidth,
            '& nav a:hover': {
                backgroundColor: palette.background.gray1Color,
            },
        },
    };
};

export default withRouter(
    connect(mapStateToProps)(injectSheet(style)(OrganizationCover)),
);



// WEBPACK FOOTER //
// ./src/containers/cover/OrganizationCover.js